import React from "react";

// (2026-05-15) Rediseño Sirius: este modal usaba estilos inline
// (position:fixed + bg-blueGray-100 + botón flotante) por lo que la capa
// global de estilos nunca lo alcanzaba y chocaba con el sidebar. Ahora usa
// el patrón estándar (overlay .fixed.inset-0.z-50 → panel blanco
// redondeado → header / body con scroll / footer en flujo). La lógica y los
// bindings de `message` se conservan idénticos.
function ModalAuditLogs({ isOpen, onClose, message }) {
  if (!isOpen) return null;

  const accion =
    message.method === "GET"
      ? "CONSULTA"
      : message.method === "POST"
      ? (message.endpoint === "/api/login" ? "INICIO DE SESIÓN" : "CREACIÓN")
      : message.method === "PUT"
      ? "ACTUALIZACIÓN"
      : "DESACTIVACIÓN/ACTIVACIÓN";

  const Item = ({ label, value, full }) => (
    <div className={full ? "w-full" : "w-full sm:w-1/3"}>
      <div className="bg-slate-50/70 rounded-xl border border-slate-200/70 p-4 h-full">
        <h3 className="text-[11px] uppercase tracking-[0.12em] font-semibold text-ink-500 mb-1.5">{label}</h3>
        <p className="text-sm font-medium text-ink-900 break-words">{value || "—"}</p>
      </div>
    </div>
  );

  return (
    <div className="fixed inset-0 z-50 flex justify-center items-center bg-black/50">
      <div className="bg-white rounded-2xl shadow-sirius-lg w-full max-w-[1100px] max-h-[90vh] flex flex-col overflow-hidden">
        {/* HEADER */}
        <div className="px-6 md:px-8 py-5 border-b border-slate-200 flex items-center justify-between bg-white">
          <h6 className="text-lg md:text-xl font-display font-bold text-ink-900">
            Detalles del registro de auditoría
          </h6>
        </div>

        {/* BODY */}
        <div className="flex-1 min-h-0 overflow-y-auto px-6 md:px-8 py-6">
          <div className="flex flex-wrap gap-3">
            <Item label="Fecha" value={message.timestamp ? message.timestamp.replace("T", " ").substr(0, 19) : ""} />
            <Item label="Servicio" value={message.endpoint} />
            <Item label="Acción" value={accion} />
            <Item label="Origen" value={message.request_ip} />
            <Item label="Respuesta" value={message.response_status_code} />
            <Item label="Duración (Ms)" value={message.duration_ms} />
            <Item label="Usuario" value={message.usuario ? message.usuario.email.toUpperCase() : ""} />
            <Item label="Usuario (Nombre)" value={message.usuario ? message.usuario.nombre.toUpperCase() : ""} />
            <Item label="Usuario (Rol)" value={message.usuario ? message.usuario.rol.toUpperCase() : ""} />
            <Item label="Encabezado de la solicitud" value={message.request_headers} full />
            <Item label="Cuerpo de la solicitud" value={message.request_body} full />
          </div>
        </div>

        {/* FOOTER */}
        <div className="shrink-0 w-full flex justify-center py-4 border-t border-slate-200 bg-white">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-slate-800 hover:bg-slate-700 text-white font-semibold rounded-xl transition"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalAuditLogs;
